module.exports = __webpack_public_path__ + "img/logo_black.c705a51c.svg";